import { PaginationBar } from "@components/PaginationBar";
import { CoinDropdownItem } from "@components/dropdown/CoinDropdownItem";
import { CustomDropdown } from "@components/dropdown/CustomDropdown";
import { MintableItemCard } from "@components/mintable/MintableItemCard";
import { useCoins } from "@contexts/CoinsContext";
import { useApi } from "@hooks/ApiHook";
import { CollectionResponse } from "baaanggg";
import React, { useState } from "react";

export interface Props {
    collection: CollectionResponse
}

export default function MintableTab({ collection }: Props) {
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState("")
    const [coinId, setCoinId] = useState<string>()
    const { coins } = useCoins()
    const { data: paginatedItems } = useApi(api => api.item.allList({ collectionId: collection.id, page, search, coinId }), [collection, page, search, coinId])

    let debounceTimer: NodeJS.Timeout;
    const onSearch = (text: string) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => setSearch(text), 500);
    };

    return <div>

        <div className="mb-10 flex items-center justify-between">
            <div className="flex items-center">
                <div className="relative mr-2.5 w-full ">
                    <input
                        onChange={({ target }) => onSearch(target.value)}
                        type="search"
                        className="w-full rounded-lg border border-jacarta-100 py-[0.5rem] px-4 pl-10 text-jacarta-700 placeholder-jacarta-500 focus:ring-accent dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder-white"
                        placeholder="Search" />
                    <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            className="h-4 w-4 fill-jacarta-500 dark:fill-white">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path
                                d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                        </svg>
                    </span>
                </div>

                <CustomDropdown
                    placeholder="Select payment type"
                    onSelected={coin => setCoinId(coin?.id)}
                    builder={(coin, isSelected) => <CoinDropdownItem
                        isSelected={isSelected}
                        coin={coin} />}
                    format={item => item.name}
                    items={coins} />
            </div>
        </div>

        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4">
            {
                paginatedItems?.data.map(item => <MintableItemCard key={item.id} item={item} />)
            }
        </div>

        <div className="mt-5"></div>

        {
            paginatedItems && <PaginationBar
                pagination={paginatedItems}
                currentPage={page}
                onPageChange={page => setPage(page)} />
        }
    </div>
}